import type { CountryLanguages } from '~/types/countryLanguages';
import type { SectionId } from '~/types/sectionId';
import type { StoryblokConfigSlug } from '~/types/storyblokConfigSlug';
import { buildLocalizedPath } from '~/utils/buildLocalizedPath';
import { findSectionConfigById } from '~/utils/findSectionConfigById';
import { resolveSectionPath } from '~/utils/resolveSectionPath';

/**
 * The start page of an area in a locale, for example `/de-de/fachportal`. Returns `null` when the area does not
 * exist in the country, or when the area is not published in the language.
 */
export function resolveSectionStartPath(
    registry: StoryblokConfigSlug[] | null | undefined,
    sectionId: SectionId,
    country: string,
    language: string,
    countryLanguages: CountryLanguages
): string | null {
    const config = findSectionConfigById(registry, country, sectionId);
    const sectionPath = config ? resolveSectionPath(config, language, countryLanguages) : null;

    return sectionPath === null ? null : buildLocalizedPath(country, language, sectionPath);
}

export function resolveSectionSwitchPath(
    registry: StoryblokConfigSlug[] | null | undefined,
    sectionId: SectionId | null | undefined,
    country: string,
    language: string,
    countryLanguages: CountryLanguages
): string {
    const startPath = sectionId
        ? resolveSectionStartPath(registry, sectionId, country, language, countryLanguages)
        : null;

    return startPath ?? buildLocalizedPath(country, language);
}
